import styled, { css } from 'styled-components';

export const List = styled.ul`
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;
    padding-left: 1rem;
`;

export const StyledListItem = styled.li`
    ${({ theme }) => css`
        position: relative;
        display: flex;
        align-items: center;
        padding: 1rem 1rem 1rem 3.5rem;
        background: ${theme.colors.secondary.tints[1].hex};
        text-decoration: none;
        margin: 0;
        min-height: 5rem;
        border-radius: 0.5rem;

        p {
            margin: 0;
        }

        @media ${theme.breakpoints.large.media} {
            padding: 1.5rem 1.5rem 1.5rem 5.5rem;
        }
    `}
`;

export const IconWrapper = styled.div`
    ${({ theme }) => css`
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: calc(50% - 1.5rem);
        left: -1rem;
        width: 3rem;
        height: 3rem;
        background-color: ${theme.colors.campaigns.clearing.primaryTintEighty.hex};
        border-radius: 0.5rem;

        @media ${theme.breakpoints.large.media} {
            top: calc(50% - 2.5rem);
            width: 5rem;
            height: 5rem;
        }
    `}
`;

export const Icon = styled.svg<{ $iconColour?: string }>`
    ${({ theme, $iconColour }) => css`
        position: relative;
        z-index: 1;
        width: 1.5rem;
        height: 1.5rem;

        ${$iconColour &&
        css`
            color: ${$iconColour};
        `}

        @media ${theme.breakpoints.large.media} {
            width: 3rem;
            height: 3rem;
        }
    `}
`;
